export const ADMIN = {
  title: 'المراجعة',
  forbiddenTitle: 'مش مسموح',
  forbiddenBody: 'الصفحة دي لفريق المراجعة بس.',
  tabsLabel: 'أقسام المراجعة',
  queue: 'الطابور',
  rules: 'الكلمات الممنوعة',
  agreements: 'الاتفاقات',
  loading: 'بنحمّل...',
  prev: 'السابق',
  next: 'التالي',
  pageOf: (page: number, pages: number) => `صفحة ${page} من ${pages}`,
  subjects: {
    garrabha_trial: 'تجربة',
    garrabha_profile: 'ملف مُجرِّب',
    garrabha_offer: 'عرض',
  } as Readonly<Record<string, string>>,
  unknownSubject: 'محتوى',
  age: (minutes: number) =>
    minutes < 1
      ? 'دلوقتي'
      : minutes < 60
        ? `من ${minutes} دقيقة`
        : minutes < 60 * 24
          ? `من ${Math.floor(minutes / 60)} ساعة`
          : `من ${Math.floor(minutes / 60 / 24)} يوم`,
  queueEmptyTitle: 'الطابور فاضي',
  queueEmptyBody: 'مفيش حاجة مستنية مراجعة.',
  matchedRule: 'اتمسك بقاعدة كلمات ممنوعة',
  open: 'افتح',
  caseTitle: 'مراجعة محتوى',
  contentTitle: 'العنوان',
  contentBody: 'النص',
  back: 'رجوع للطابور',
  decision: 'القرار',
  approve: 'وافق',
  needsInfo: 'محتاج معلومة',
  reject: 'ارفض',
  question: 'السؤال لصاحب المحتوى',
  reason: 'سبب الرفض',
  questionRequired: 'اكتب السؤال.',
  reasonRequired: 'اكتب السبب.',
  decided: 'القرار اتسجّل.',
  rulesTitle: 'الكلمات الممنوعة',
  rulesIntro: 'أي محتوى فيه كلمة من دول بيتراجع على طول.',
  ruleValue: 'الكلمة أو العبارة',
  ruleNote: 'ملاحظة (اختياري)',
  addRule: 'ضيف',
  ruleAdded: 'الكلمة اتضافت.',
  deleteRule: 'امسح',
  deleteRuleTitle: 'تمسح الكلمة دي؟',
  deleteRuleConfirm: 'امسح',
  rulesEmpty: 'مفيش كلمات ممنوعة لسه.',
  agreementsEmpty: 'مفيش اتفاقات لسه.',
  owner: 'صاحب التجربة',
  trier: 'المُجرِّب',
  amount: 'القيمة',
  status: 'الحالة',
} as const;
